import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { LANGS, useI18n } from "@/i18n";
import { fetchNav } from "@/lib/nav";
import HelpBubble from "@/components/HelpBubble";
import { SubmitBar } from "@/components/SubmitModal";

function navTestId(label) {
  return `nav-${(label || "item").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;
}

export function SiteHeader() {
  const { lang, setLang } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchNav().then(setItems);
  }, []);

  return (
    <header className="dd-header" data-testid="site-header">
      <div className="dd-wrap">
        <nav className="dd-nav">
          <div className="dd-nav-links">
            {items.map((it, i) => it.url.startsWith("/") ? (
              <NavLink
                key={`${it.label}-${i}`}
                to={it.url}
                end={it.url === "/"}
                className={({ isActive }) => `dd-navlink${isActive ? " is-active" : ""}`}
                data-testid={navTestId(it.label)}
              >
                {it.label}
              </NavLink>
            ) : (
              <a key={`${it.label}-${i}`} href={it.url} target="_blank" rel="noreferrer" className="dd-navlink" data-testid={navTestId(it.label)}>
                {it.label}
              </a>
            ))}
          </div>
          <div className="dd-nav-side">
            <div className="dd-lang" role="group" aria-label="Language" data-testid="language-toggle">
              {LANGS.map((l) => (
                <button
                  key={l.code}
                  type="button"
                  className={`dd-lang-btn${lang === l.code ? " is-active" : ""}`}
                  onClick={() => setLang(l.code)}
                  aria-pressed={lang === l.code}
                  title={l.name}
                  data-testid={`lang-${l.code}`}
                >
                  {l.label}
                </button>
              ))}
            </div>
            <SubmitBar compact />
          </div>
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <>
      <footer className="dd-footer" data-testid="site-footer">
        <div className="dd-wrap">© {year} San Juanillo Rising</div>
      </footer>
      <HelpBubble />
    </>
  );
}
